import router from '@/router';  
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';  

NProgress.configure({ showSpinner: false }); // NProgress Configuration
 
router.beforeEach(async(to, from, next) => {
    NProgress.start();
 
    // 设置页面标题
    document.title = to.meta.title+'-理工比特林克'; 
 
    next(); 
});

router.afterEach(() => {
    NProgress.done()
});